/* eslint-disable no-console */
<template>
  <v-app id="app">
    <v-main>
      <!-- Aufbau wie die Anmeldung von Mobility Hub (Kontrolle): links Formular, rechts Bild, schmal nur Formular -->
      <div class="login">
        <div class="login__panel">
          <div class="login__brand">
            <img src="/img/sima-star.png" alt="SIMA" width="22" height="22" class="login__star" />
            <span>
              <span class="login__product">Ticketing</span>
              <span class="login__version">v{{ version }}</span>
            </span>
          </div>

          <div class="login__center">
            <form class="login__form" novalidate @submit.prevent="submit">
              <div class="login__head">
                <h1 class="login__title">Anmelden</h1>
                <p class="login__sub">Wählen Sie Ihren Kunden und geben Sie Benutzername und Passwort ein</p>
              </div>

              <div v-if="errorMessage" class="login__error" role="alert">{{ errorMessage }}</div>

              <div class="login__fields">
                <div class="login__field">
                  <label class="login__label" for="login-customer">Kunde</label>
                  <!-- Suchfeld statt langer Auswahlliste (Kundenwunsch 13.10.2026) -->
                  <login-customer-field
                    ref="customer"
                    v-model="customerId"
                    input-id="login-customer"
                    :customers="customers"
                    :disabled="loading"
                    @chosen="focusUser"
                  />
                </div>

                <div class="login__field">
                  <label class="login__label" for="login-user">Benutzername</label>
                  <input
                    id="login-user"
                    ref="user"
                    v-model="username"
                    name="user"
                    type="text"
                    class="login__input"
                    autocomplete="username"
                    autocapitalize="none"
                    spellcheck="false"
                    :disabled="loading"
                  />
                </div>

                <div class="login__field">
                  <label class="login__label" for="login-password">Passwort</label>
                  <input
                    id="login-password"
                    v-model="password"
                    name="password"
                    type="password"
                    class="login__input"
                    autocomplete="current-password"
                    :disabled="loading"
                  />
                </div>

                <button type="submit" class="login__button" :disabled="loading">
                  {{ loading ? "Anmeldung läuft …" : "Anmelden" }}
                </button>
              </div>
            </form>
          </div>

          <p class="login__copyright">
            Copyright © {{ moment().format("YYYY") }} SIMA Software Solutions GmbH. Alle Rechte vorbehalten.
          </p>
        </div>

        <div class="login__image" aria-hidden="true">
          <img src="/img/login-luftbild.jpg" alt="" />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { Auth } from "aws-amplify";
import axios from "axios";
import moment from "moment";
import LoginCustomerField from "@/components/login/LoginCustomerField";

export default {
  components: { LoginCustomerField },
  props: {
    source: String,
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    customerId: null,
    customerName: null,
    username: null,
    password: null,
    loading: false,
    errorMessage: null,
    customers: [],
  }),
  watch: {
    customerId() {
      const filtered = this.customers.filter(
        (customer) => customer.customer_id === this.customerId
      );
      if (filtered && filtered.length > 0) {
        this.customerName = filtered[0].name;
      } else {
        this.customerName = null;
      }
    },
  },
  async mounted() {
    // Browser-Tab wie im Mobility Hub („Mobility Hub | Anmelden“)
    document.title = "Ticketing | Anmelden";
    try {
      const response = await axios
        .create()
        .get(`${this.$store.state.baseUrl}customerpublic`);
      // console.log({ response });
      this.customers = response.data;

      let customer_id = localStorage.getItem("login_customer_id") || this.$route.query.customer_id;

      // nur bekannte Kunden vorbelegen (früher konnte „null“ gespeichert sein)
      const id = parseInt(customer_id);
      if (Number.isFinite(id) && this.customers.some((customer) => customer.customer_id === id)) {
        this.customerId = id;
      }
    } catch (error) {
      // console.log({ error });
    }
  },
  methods: {
     moment() {
      return moment();
    },
    // Absenden per Knopf oder Enter; kein zweites Absenden, solange die Anmeldung läuft; ohne Kunden zuerst wählen
    submit() {
      if (this.loading) return;
      if (this.customerId === null) {
        this.errorMessage = "Bitte wählen Sie Ihren Kunden.";
        this.$refs.customer.focus();
        return;
      }
      this.signIn();
    },
    // nach der Wahl des Kunden weiter zum Benutzernamen (leer) bzw. Passwort
    focusUser() {
      if (this.errorMessage === "Bitte wählen Sie Ihren Kunden.") {
        this.errorMessage = null;
      }
      this.$nextTick(() => {
        const next = this.username ? document.getElementById("login-password") : this.$refs.user;
        if (next) {
          next.focus();
        }
      });
    },
    async signIn() {
      localStorage.setItem("login_customer_id", this.customerId);

      this.loading = true;
      this.errorMessage = null;
      try {
        const user = await Auth.signIn(
          `${this.customerId}_${this.username}`,
          `bconn${this.password}`
        );
        if (
          user.challengeName === "SMS_MFA" ||
          user.challengeName === "SOFTWARE_TOKEN_MFA"
        ) {
          this.errorMessage = "Multifaktor Authentifikation Token.";
        } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.errorMessage = "Neues Passwort benötigt.";
        } else if (user.challengeName === "MFA_SETUP") {
          this.errorMessage = "Multifaktor Authentifikation Setup.";
        } else {
          this.$store.commit("setIsUserLoggedIn", true);
          this.$store.commit("setCustomerId", this.customerId);
          this.$store.commit("setCustomerName", this.customerName);
          this.$store.commit("setCognitoUsername", user.username);
          const profile = (
            await axios.get(`${this.$store.state.baseUrl}profile`)
          ).data;
          this.$store.commit("setProfile", profile);
          const customer = (
            await axios.get(`${this.$store.state.baseUrl}customer`)
          ).data;
          this.$store.commit("setCustomer", customer);
          this.$router.push("/overview");
        }
      } catch (err) {
        if (err.code === "UserNotConfirmedException") {
          this.errorMessage =
            "Benutzer ist nicht bestätigt, bitte kontaktieren Sie den Administrator.";
        } else if (err.code === "PasswordResetRequiredException") {
          this.errorMessage =
            "Passwort muss zurückgesetzt werden, bitte kontaktieren Sie den Administrator.";
        } else if (err.code === "NotAuthorizedException") {
          this.errorMessage = "Falscher Benutzername oder Passwort.";
        } else if (err.code === "UserNotFoundException") {
          this.errorMessage = "Falscher Benutzername oder Passwort.";
        } else {
          this.errorMessage =
            "Die Anmeldung ist fehlgeschlagen. Bitte prüfen Sie Ihre Eingaben und versuchen Sie es erneut.";
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
#app {
  background-color: #ffffff;
}
</style>

<style scoped>
.login {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-height: 100vh;
  min-height: 100svh;
  background: #fff;
  color: var(--ink);
  font-family: var(--font);
  -webkit-font-smoothing: antialiased;
}

/* Linke Seite: Marke oben, Formular mittig, Copyright unten */
.login__panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
}
.login__brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
}
.login__star {
  width: 22px;
  height: 22px;
  flex: none;
}
.login__product {
  font-weight: 600;
}
.login__version {
  margin-left: 6px;
  color: var(--ink-3);
}
.login__center {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login__form {
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.login__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}
.login__title {
  margin: 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.login__sub {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--ink-3);
  text-wrap: balance;
}
.login__error {
  padding: 12px;
  border-radius: 6px;
  background: var(--red-t);
  color: var(--red);
  font-size: 14px;
  line-height: 20px;
}
.login__fields {
  display: grid;
  gap: 20px;
}
.login__field {
  display: grid;
  gap: 8px;
}
.login__label {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: var(--ink);
}

/* Felder im Feldstil der Verwaltung: Rahmen rundum einheitlich (--field-edge, weich) */
.login__input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  margin: 0;
  padding: 0 12px;
  border: 1px solid var(--field-edge);
  border-radius: 6px;
  background: #fff;
  color: var(--ink);
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
}
.login__input:hover:not(:disabled) {
  border-color: var(--field-edge-hover);
}
.login__input:focus-visible {
  outline: 2px solid var(--link);
  outline-offset: 2px;
}
.login__input:disabled {
  background: var(--dis-bg);
  color: var(--ink-3);
}
/* Primärknopf wie in der Verwaltung und im Mobility Hub: Orange mit weißer Schrift ohne Kante (Kundenwunsch 13.10.2026) */
.login__button {
  width: 100%;
  height: 36px;
  margin: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: var(--acc);
  box-shadow: var(--sh-ctl);
  color: var(--on-acc);
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
}
.login__button:hover:not(:disabled) {
  background: var(--pri-hov);
}
.login__button:active:not(:disabled) {
  background: var(--pri-press);
}
.login__button:focus-visible {
  outline: 2px solid var(--link);
  outline-offset: 2px;
}
.login__button:disabled {
  border-color: var(--dis-bg);
  background: var(--dis-bg);
  box-shadow: none;
  color: var(--ink-3);
  cursor: default;
}

.login__copyright {
  margin: 0;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  color: var(--ink-3);
}

/* Rechte Seite: Bild, nur auf breiten Bildschirmen */
.login__image {
  position: relative;
  display: none;
  overflow: hidden;
  background: var(--chrome);
}
.login__image img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right;
}

@media (min-width: 768px) {
  .login__panel {
    padding: 24px 40px;
  }
  .login__brand {
    justify-content: flex-start;
  }
}
@media (min-width: 1024px) {
  .login {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .login__image {
    display: block;
  }
}

/* Touch und Handy: Ziele 44 px, Eingabe 16 px (iOS zoomt sonst beim Antippen) */
html.dichte-touch .login__input,
html.dichte-touch .login__button {
  height: 44px;
  font-size: 16px;
}
@media (max-width: 599px) {
  .login__input,
  .login__button {
    height: 44px;
    font-size: 16px;
  }
}
</style>
